import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProiecteComponent } from './proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddProiecteComponent } from './add-proiecte/add-proiecte.component';
import { DetaliiProiecteComponent } from './detalii-proiecte/detalii-proiecte.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ContinutProiectComponent } from './detalii-proiecte/continut-proiect/continut-proiect.component';
import { ResponsabiliProiectComponent } from './detalii-proiecte/responsabili-proiect/responsabili-proiect.component';
import { ActualizareProiectComponent } from './detalii-proiecte/actualizare-proiect/actualizare-proiect.component';
import { MesagerieComponent } from './detalii-proiecte/mesagerie/mesagerie.component';
import { OperatoriProiectComponent } from './detalii-proiecte/operatori-proiect/operatori-proiect.component';
import { UpdateFurnizorProiectComponent } from './detalii-proiecte/update-furnizor-proiect/update-furnizor-proiect.component';
import { UpdateCategorieProiectComponent } from './detalii-proiecte/update-categorie-proiect/update-categorie-proiect.component';
import { ActiuniProiectCardComponent } from './detalii-proiecte/actiuni-proiect-card/actiuni-proiect-card.component';
import { ModalInchidereProiectComponent } from './detalii-proiecte/modal-inchidere-proiect/modal-inchidere-proiect.component';
import { InfoInchidereProiectComponent } from './detalii-proiecte/info-inchidere-proiect/info-inchidere-proiect.component';
import { IstoricProiectComponent } from './detalii-proiecte/istoric-proiect/istoric-proiect.component';
import { LocatieProiectComponent } from './detalii-proiecte/locatie-proiect/locatie-proiect.component';
import { UpdateCompartimentProiectComponent } from './detalii-proiecte/update-compartiment-proiect/update-compartiment-proiect.component';

@NgModule({
    declarations: [
        ProiecteComponent,
        AddProiecteComponent,
        DetaliiProiecteComponent,
        ContinutProiectComponent,
        ResponsabiliProiectComponent,
        ActualizareProiectComponent,
        MesagerieComponent,
        OperatoriProiectComponent,
        UpdateFurnizorProiectComponent,
        UpdateCategorieProiectComponent,
        ActiuniProiectCardComponent,
        ModalInchidereProiectComponent,
        InfoInchidereProiectComponent,
        IstoricProiectComponent,
        LocatieProiectComponent,
        UpdateCompartimentProiectComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        GoogleMapsModule
    ],
    exports: [ProiecteComponent],
})
export class ProiecteModule { }
